import type { ClientSDK } from '@wix/installation-manager-client-sdk';
import type { IInstaller } from '@wix/app-market-core';
import type { ReadOnlyExperiments } from '@wix/wix-experiments';
import type { IHttpClient } from '@wix/http-client';
import type { i18n } from '@wix/wix-i18n-config';
import type { InstallApp } from '@wix/app-installer';

export class Installer implements IInstaller {
  private readonly clientSDK: ClientSDK;
  private readonly newInstallerInstallApp: InstallApp;
  private readonly installedVersionOverride?: string;
  private readonly version?: 'dev';
  private readonly referredByAppId?: string;
  private readonly shareUrlId?: string;
  private readonly experiments: ReadOnlyExperiments;
  private readonly i18n: i18n;
  private readonly httpClient: IHttpClient;

  constructor({
    clientSDK,
    newInstallerInstallApp,
    installedVersionOverride,
    referredByAppId,
    experiments,
    shareUrlId,
    version,
    httpClient,
    i18n,
  }: {
    clientSDK: ClientSDK;
    newInstallerInstallApp: InstallApp;
    installedVersionOverride?: string;
    shareUrlId?: string;
    referredByAppId?: string;
    version?: 'dev';
    experiments: ReadOnlyExperiments;
    httpClient: IHttpClient;
    i18n: i18n;
  }) {
    this.newInstallerInstallApp = newInstallerInstallApp;
    this.clientSDK = clientSDK;
    this.installedVersionOverride = installedVersionOverride;
    this.referredByAppId = referredByAppId;
    this.experiments = experiments;
    this.httpClient = httpClient;
    this.shareUrlId = shareUrlId;
    this.i18n = i18n;
    this.version = version;
  }

  installApp: IInstaller['installApp'] = ({
    appId,
    consentOpeningMethod,
    onSuccess,
    onFailure,
    correlationId,
  }) => {
    if (
      this.experiments?.enabled('spec.dcc.newInstallerAppMarketStandalone') ||
      this.shareUrlId
    ) {
      this.newInstallerInstallApp({
        appId,
        tenantType: 'SITE',
        version: this.version,
        versionOverrideId: this.installedVersionOverride,
        shareUrlId: this.shareUrlId,
        correlationId,
      })
        .then((response) => {
          if (response.status === 'SUCCESS') {
            const instanceId = response.installedApps[0].instanceId;
            onSuccess(instanceId);
          }
        })
        .catch((e: Error) => onFailure(e.message));
    } else {
      this.clientSDK.installApp({
        appDefId: appId,
        openMethod: consentOpeningMethod,
        version: this.installedVersionOverride,
        onInstallationSuccess: ({ instanceId }) => {
          onSuccess?.(instanceId);
        },
        onInstallationFail: ({ reason: failureReason }) => {
          onFailure?.(failureReason);
        },
        referredByAppId: this.referredByAppId,
      });
    }
  };
}
